import { InjectionToken } from '@angular/core';

export interface Environment {
  apiUrl: string;
  appID: string;
  assessmentsCollection: string;
  auth0Audience?: string;
  auth0ClientId: string;
  auth0Domain: string;
  auth0RedirectUri: string;
  auth0LogoutRedirectUri?: string;
  auth0Scope?: string;
  consentRefusalCollection?: string;
  databaseName: string;
  enrollTherapistFunction: string;
  enrollmentFunction?: string;
  ineligibleAssessmentCollection?: string;
  postcodesCollection: string;
  production?: boolean;
  profilesCollection: string;
  responseLogCollection: string;
  responseLogFunction: string;
}

export const ENVIRONMENT_TOKEN: InjectionToken<Environment> =
  new InjectionToken('ENVIRONMENT_TOKEN');
